import { Component, OnInit,Input } from '@angular/core';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';

@Component({
  selector: 'app-widget-images-banner-two',
  templateUrl: './widget-images-banner-two.component.html',
  styleUrls: ['./widget-images-banner-two.component.scss'],
})
export class WidgetImagesBannerTwoComponent implements OnInit {
  @Input() data: any;
  constructor(private widgetsService:WidgetsService) { }

  ngOnInit() {}

  async onClickBanner(bannerData: any) {
    this.widgetsService.bannerLink(bannerData);
  }

}
